export default "__VITE_ASSET__CzMymroZ__"